import store from '@/store'

let conf

function redirect(target, query) {
    if (!target) return
    const {token} = store.state.auth
    const queryString = urlEncode(query)
    let a = document.createElement('a')
    a.href = `${conf.api.baseURL}/${target}?token=${token}${queryString}`
    a.click()
}

var urlEncode = function (param, key, encode) {
    if (param == null) return '';
    var paramStr = '';
    var t = typeof (param);
    if (t == 'string' || t == 'number' || t == 'boolean') {
        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param);
    } else {
        for (var i in param) {
            var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i)
            paramStr += urlEncode(param[i], k, encode)
        }
    }
    return paramStr;

}

const linkHelper = {
    redirect,
}

export default {

    install(Vue, config) {
        conf = config
        Vue.prototype.$linkHelper = linkHelper
    }

}
